/**
 * CSRF protection for admin-ui.
 * Reads the CSRF token from the csrf_token cookie (set by the Go BFF)
 * and includes it in mutation request headers.
 */

export function getCsrfHeaders(): Record<string, string> {
    const token = getCsrfToken();
    return token ? { "X-CSRF-Token": token } : {};
}

export function getCsrfToken(): string {
    if (typeof document === "undefined") return "";
    const match = document.cookie
        .split("; ")
        .find((row) => row.startsWith("csrf_token="));
    return match?.split("=")[1] ?? "";
}
